export default __webpack_public_path__ + "static/media/UserManagement.ce268759.PNG";